import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaces from "common/datahooks/useWorkspaces";
import { getWhitelabelCustomization } from "common/helpers/utils";

export default function usePageTitle() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { workspaces } = useWorkspaces();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  // the current path without the workspaceId
  const strippedPathname = location.pathname.replace(
    getWhitelabelCustomization() && workspaces.length === 1
      ? "/"
      : `/workspaces/${workspaceId}/`,
    "",
  );
  const currentPathComponents = strippedPathname.split("/");

  const translationNamespace = currentPathComponents[0];
  let translationPathComponents = [currentPathComponents[1]];

  const hasNestedTitle = i18n.exists(
    [...translationPathComponents, "title"].join("."),
    {
      ns: translationNamespace,
    },
  );
  if (!hasNestedTitle) {
    translationPathComponents = [];
  }

  return t([...translationPathComponents, "title"].join("."), {
    ns: translationNamespace,
  });
}
